module.exports = __webpack_public_path__ + "media/giving-back/responsible-3c0cea22.webp";